// extracted by mini-css-extract-plugin
export var productImage = "_rz-1";
export var viewLink = "_rz-2";
export var wishlistItem = "_rz-0";